import React from "react";

/**
 * BrandWordmark
 * -------------
 * The "GYM with GRIZZ" logo, shown in the header on every page.
 *
 * On hover we light a soft cyan→blue flame-glow underneath the wordmark via
 * pure CSS — no JS, no extra DOM weight, no animation library. The glow is
 * drawn with a layered `text-shadow` blur on the heavy stencil glyphs and a
 * faint radial-gradient halo behind the whole word. It pulses subtly via
 * `@keyframes brand-flame` (declared in index.css) so the effect feels
 * alive without being distracting.
 */
export default function BrandWordmark({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl",
    xl: "text-5xl sm:text-6xl",
  };
  return (
    <span
      data-testid="brand-wordmark"
      className={`brand-wordmark relative inline-block font-display tracking-wider leading-none ${sizes[size]} ${className}`}
    >
      {/* Flame halo — sits behind the text, only visible on hover via CSS */}
      <span aria-hidden className="brand-wordmark__flame" />
      <span className="brand-wordmark__text relative">
        GYM{" "}
        <span
          className="opacity-60 italic font-light tracking-normal text-[0.55em]"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          with
        </span>{" "}
        <span className="text-blue-500">GRIZZ</span>
      </span>
    </span>
  );
}
